import { ModuleRegisterFn } from "@/module-register"

const registerPhoneClaimModule: ModuleRegisterFn = () => {
  // Routes are assembled by src/router; no event listeners needed
}

export default registerPhoneClaimModule
